var shopify_store_domain = Shopify.shop;
var shopify_brand_name = "Lea";
var shopify_brand_colour = "#000000";
var popup_image = "https://websdk-assets.s3.ap-south-1.amazonaws.com/shopify-messaging-app/lea_popup.png"
var shopify_brand_logo =
  "https://websdk-assets.s3.ap-south-1.amazonaws.com/shopify-messaging-app/cellbell.gif";

var shopify_product_price_xpath = [
  "/html/body/div[8]/main/div[1]/section/div[1]/div[2]/div/div/div[1]/div[2]/span",
  "/html/body/div[7]/main/div[1]/section/div[1]/div[2]/div/div/div[1]/div[2]/span"
]

var shopify_cart_price_xpath =
  "/html/body/div[6]/form/div[2]/button[2]/span[3]";

var shopify_product_box_location_xpaths = [
  "/html/body/div[8]/main/div[1]/section/div[1]/div[2]/div/div/div[1]/div[2]",
  "/html/body/div[7]/main/div[1]/section/div[1]/div[2]/div/div/div[1]/div[2]"
]
var shopify_cart_box_location_xpath = "/html/body/div[6]/form/div[2]/p";

var isPaise = false;

const parser = new DOMParser();

var pay_in_3_button_configuration = {};

function getXPathData(xpath) {
  return document.evaluate(
    xpath,
    document,
    null,
    XPathResult.FIRST_ORDERED_NODE_TYPE,
    null
  ).singleNodeValue;
}

function getElementByXpath(xpath) {
  var selector;

  selector = xpath.replace(/^\s*\/\s*/g, "");
  selector = selector.replace(/\s*\/\s*/g, " > ");
  selector = selector.replace(/\[(\d+)\]/g, function (n) {
    return ":nth-of-type(" + n[1] + ")";
  });

  return document.querySelector(selector);
}

function getInstallment(productPrice) {
  let installmentPrice = 0;

  installmentPrice = (productPrice / 3).toFixed(2);

  return installmentPrice;
}


function cleanPrice(productPrice, isPaiseOverride) {
  let cleanedProductPrice = productPrice


  if (typeof productPrice === "string") {
    cleanedProductPrice = productPrice.replace(/[^0-9.]+/g, "").trim().match(/\d+\.?\d*/);

    cleanedProductPrice = parseFloat(cleanedProductPrice);
  }
  return cleanedProductPrice;
}

function refreshProductPrice(
  price_algo_override,
  product_price_strings,
  location
) {
  for (let i = 0; i < product_price_strings.length; i++) {
    const product_price_string = product_price_strings[i];
    try {
      let textContent = getXPathData(product_price_string).textContent;

      const productPrice = getProductPrice(price_algo_override, textContent);

      const installmentPrice = getInstallment(productPrice.price);

      // const bxTotalPrice = document.getElementById(`bx-total-price-${location}`);
      const bxInstallment = document.getElementById(`bx-installment-${location}`);

      // bxTotalPrice.textContent = `â‚¹${productPrice.price}`;
      bxInstallment.textContent = `â‚¹${installmentPrice}`;
      return;
    } catch (e) {
      // console.log(e);
    }
  }
}

function getProductPrice(price_algo_override, product_price_string) {
  switch (price_algo_override) {
    case 1: {
      let price = cleanPrice(product_price_string);

      return {
        price: price,
        variant_id: -1,
      };
    }
    default: {
      let varId = window.ShopifyAnalytics.meta.selectedVariantId;
      let vars = window.ShopifyAnalytics.meta.product.variants;

      for (let x of vars) {
        if (x.id === varId) {
          return {
            price: cleanPrice(product_price, true),
            variant_id: varId,
          };
        }
      }

      return {
        price: cleanPrice(vars[0].price, true),
        variant_id: varId,
      };
    }
  }
}

function loadBxModal() {
  var modal_html =
    `<div id="bx-modal" style="display: none;justify-content: center; position: fixed; z-index: 2147483649;left: 0; top: 0; border: 0 ;width: 100%; max-width: 100%; height: 100vh; background-color: rgb(18,18,18,0.55); overflow: auto; opacity : 1;" class="modal"> <div class="bx-modal-content" style="background-color: #fefefe; background: transparent; width: 40%;min-width: 360px;max-width: 420px; display: flex; align-items: center; justify-content: center; border: 0; position: relative"> <div class="image"> <img id="bx-image-popup" style="width: 100%; height: 100%" src="${popup_image}" alt="Pay in 3"> </div> </div></div>`;

  var modal = document.getElementById("bx-modal");
  var btn = document.getElementById("bharatx-text-block-with-price-product");

  if (btn != null) {
    btn.onclick = function () {
      if (modal == null) {
        document.getElementsByTagName("body")[0].innerHTML += modal_html;
        modal = document.getElementById("bx-modal");
        modal.onclick = function () {
          // console.log("modal closed");
          modal.style.display = "none";
          btn = document.getElementById(
            "bharatx-text-block-with-price-product"
          );
          btn.onclick = function () {
            window.onclick = function (event) {
              if (event.target == modal) {
                // console.log("modal closed outside click");
                modal.style.display = "none";
              }
            };
            modal = document.getElementById("bx-modal");
            modal.style.display = "flex";
            // console.log("btn clicked");
          };
        };
        window.onclick = function (event) {
          if (event.target == modal) {
            // console.log("modal closed outside click");
            modal.style.display = "none";
          }
        };
      }
      modal = document.getElementById("bx-modal");
      modal.style.display = "flex";
      // console.log("btn clicked");
    };
  }
}

function getUiForBxBox(price_override, product_price_string, location) {
  var price_string = null;
  if (product_price_string) {
    price_string = getXPathData(product_price_string).textContent;
  }

  const productDetails = getProductPrice(
    price_override ?? 2,
    price_string,
    location
  );

  const installmentPrice = getInstallment(productDetails.price);

  if (productDetails.price > 0) {
    const frontend = `
  <div id="bx-ui-box-${location}"> 
    <div id ="bharatx-text-block-with-price-${location}" class="button--full-width" style="
      cursor: pointer;
      color: #ffffff;
      border: 2px solid #8787878a; 
      width: fit-content; 
      align-items: center; 
      justify-content: space-between; 
      display: flex; 
      width: 100%; 
      padding: 5px 5px; 
      gap: 6px;
      margin: 8px 0px; 
      flex-direction: row; 
      align-items: center; 
      min-height : 45px;
      max-width: 400px;
    "> 
      <div class = "bx-box" id= "bx-box-${location}" style="display: flex; flex-direction: row ; max-width: 100%; align-items: center">
      <div style= "margin-right:5px;">
        <p class="bx-text" style="font-size: 16px; margin: 0px; font-weight:500; line-height: 20px; color : #6a6a6a">
          or Pay <span id="bx-installment-${location}" style="font-weight: bold; color: ${shopify_brand_colour}; font-weight: 700;"> â‚¹${installmentPrice} </span> now and rest via 
          </p>
        </div>
        <img style="height: 2rem;" src="https://websdk-assets.s3.ap-south-1.amazonaws.com/shopify-messaging-app/LEAGroup_logo.png"></img>
         </div> <div style="display: flex; align-items: center"> <img id = "inf" style="max-width: 21px" viewBox="0 0 512 512" src="https://websdk-assets.s3.ap-south-1.amazonaws.com/shopify-messaging-app/info_default.png"> </img> </div> </div></div>`;

    return frontend;
  }
}

function loadInfoBanner() {
  const ui = getUiForBxBox(null, null, "product");

  if (!document.getElementById("bx-ui-box-product")) {

    for (let i = 0; i < shopify_product_box_location_xpaths.length; i++) {
      var referenceNode = getElementByXpath(shopify_product_box_location_xpaths[i]);
      if (referenceNode) {

        const domObject = parser.parseFromString(ui, "text/html").body
          .childNodes[0];

        referenceNode.parentNode.insertBefore(
          domObject,
          referenceNode.nextElementSibling
        );
        return;
      }
    }
  }
}

function loadCartBanner() {
  const ui = getUiForBxBox(1, shopify_cart_price_xpath, "cart");

  if (document.getElementById("bx-ui-box-cart") == null && ui != null) {
    var referenceNode = getElementByXpath(shopify_cart_box_location_xpath);

    const domObject = parser.parseFromString(ui, "text/html").body
      .childNodes[0];

    referenceNode.parentNode.insertBefore(
      domObject,
      referenceNode.nextElementSibling
    );
  }
}

function addCartButton() {
  try {
    var ui =
      '<div id="bx-btn-cart" style="cursor: pointer; padding-top: 10px;"> <div id="bharatx-text-block-with-price" class="sf__btn flex-grow shrink not-change relative sf__btn-primary" style="color: #FFFFFF; background-color: #e0657f; border: none;align-items: center; justify-content: center; display: flex; width: 100%; padding: 13px 28px; flex-direction: row; align-items: center; margin-top : -10px ;"> <div style="display: flex; flex-direction: row; gap: 8px; max-width: 100%; align-items: center"> <p style="margin: 0px; line-height: 20px; font-size:17px "> Pay 1/3 now, and 2 EMIs later</p> </div> </div></div>';

    var referenceNode = getElementByXpath(shopify_cart_box_location_xpath);

    const domObject = parser.parseFromString(ui, "text/html").body
      .childNodes[0];

    referenceNode.parentNode.insertBefore(
      domObject,
      referenceNode.nextElementSibling
    );
  } catch (err) { }
}

function getRedirectUrlCart() {
  try {
    const bxCartButton = document.getElementById("bx-btn-cart");
    bxCartButton.addEventListener("click", function () {
      fetch(window.Shopify.routes.root + "cart.js")
        .then((e) => e.json())
        .then((t) => {
          var variantIdsWithQuantities = [];
          for (const item of t.items) {
            variantIdsWithQuantities.push({
              productVariantId: item.variant_id.toString(),
              quantity: item.quantity,
            });
          }

          fetch("https://web-v2.bharatx.tech/api/shopify/checkoutCart", {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({
              domain: shopify_store_domain,
              productVariantIdsWithQuantities: variantIdsWithQuantities,
            }),
          })
            .then((response) => response.text())
            .then(
              (data) => (window.location.href = JSON.parse(data).checkoutWebUrl)
            )
            .catch((err) => {
              // console.log(err);
            });
        });
    });
  } catch (err) {
    // console.log(err)
  }
}

function bxOps() {

  try {
    var x = window.matchMedia("(max-width: 700px)");

    const boxId = document.getElementsByClassName("bx-box")
    const id = document.getElementsByClassName("bx-text");
    const productById = document.getElementById("bx-box-product")

    for (let i = 0; i < boxId.length; i++) {
      if (!x.matches) {
        boxId[i].style.flexDirection = "row"
        boxId[i].style.alignItems = "center"
        productById.style.marginLeft = "0px"
      }

      if (x.matches) {
        boxId[i].style.flexDirection = "column"
        boxId[i].style.alignItems = "center"
        productById.style.marginLeft = "60px"
      }
    }

    for (let i = 0; i < id.length; i++) {
      if (!x.matches) {
        id[i].style.fontSize = "12px";

      }

      if (x.matches) {
        id[i].style.fontSize = "12px";
      }
    }
  } catch (e) { }
  try {
    document.getElementById("simpl_product_div").style.display = "none";
  } catch (e) { }

  try {
    if (document.getElementById("bx-ui-box-product") == null) {
      loadInfoBanner();
      loadBxModal();
    }
  } catch (e) { console.log(e) }

  try {
    if (document.getElementById("bx-ui-box-cart") == null) {
      loadCartBanner();
    }
  } catch (e) { }

  try {
    if (document.getElementById("bx-ui-box-cart")) {
      refreshProductPrice(1, shopify_cart_price_xpath, "cart");
    }
    if (document.getElementById("bx-ui-box-product")) {
      refreshProductPrice(1, shopify_product_price_xpath, "product");
    }
  } catch (e) { }
}

setInterval(bxOps, 400);